import {BaseEntity, IBaseEntity} from 'app/blocks/model/base-entity.model';

export interface IAdvanceQuery extends IBaseEntity {
    id?: number;
    tenantName;
    tableName;
    description;
    queryType;
    enable;
    columns;
    updates;
    clauses;
}

export class AdvanceQuery extends BaseEntity implements IAdvanceQuery {
    id?: number;
    tenantName;
    tableName;
    description;
    queryType;
    enable;
    columns;
    updates;
    clauses;

    constructor(advanceQuery?) {
        super();
        if (advanceQuery) {
            this.id = advanceQuery.id;
            this.tenantName = advanceQuery.tenantName;
            this.tableName = advanceQuery.tableName;
            this.description = advanceQuery.description;
            this.queryType = advanceQuery.queryType;
            this.enable = advanceQuery.enable;
            this.columns = advanceQuery.columns;
            this.updates = advanceQuery.updates;
            this.clauses = advanceQuery.clauses;
        }
    }

    clone(): AdvanceQuery {
        return new AdvanceQuery(this);
    }

    get discriminator(): any {
        return this.id;
    }
}
